// Semua baris: Start Time = PDF start_time + 1 menit
export const BASE_OFFSET_MINUTES = 1;

// Origin ini butuh headway 3 menit lebih awal DARI Start Time
export const SPECIAL_OFFSET_ORIGINS = new Set([
  "CT1",
  "CT2",
  "INT1",
  "INT2",
  "WLT",
  "ERT",
]);
// Backward compat name
export const OFFSET_ORIGINS = SPECIAL_OFFSET_ORIGINS;

const isSpecialOrigin = (row) =>
  SPECIAL_OFFSET_ORIGINS.has(
    String(row?.track_origin || "").trim().toUpperCase(),
  );

/**
 * Row berasal dari DAL (depo) — keberangkatan kereta KELUAR depo.
 * Ditampilkan dengan warna font berbeda + tanpa startup T-30 reminder.
 */
export const isFromDal = (row) =>
  String(row?.track_origin || "").trim().toUpperCase().startsWith("DAL");

/**
 * Net menit yang ditambahkan ke waktu PDF untuk mendapatkan waktu efektif.
 *   DAL (Pulang) : -1  (keberangkatan keluar depo → -1 menit dari PDF)
 *   Normal        : +1
 *   Special origin: +1 − 3 = −2
 */
export const totalOffsetMinutes = (row) => {
  if (isFromDal(row)) return -1;
  return BASE_OFFSET_MINUTES + (isSpecialOrigin(row) ? -3 : 0);
};

// For UI: minutes to subtract label. If negative → PDF-x, if positive → PDF+x
export const displayOffsetLabel = (row) => {
  const n = totalOffsetMinutes(row);
  if (n === 0) return null;
  return n > 0 ? `+${n}m` : `−${Math.abs(n)}m`;
};

export const parseHM = (hm, ref) => {
  const [h, m] = String(hm || "00:00")
    .split(":")
    .map((n) => parseInt(n, 10) || 0);
  const d = new Date(ref);
  d.setHours(h, m, 0, 0);
  return d;
};

/**
 * Coerce a Date OR YYYY-MM-DD string ke Date object di local midnight.
 * Pakai untuk ref parseHM kalau caller mau override tanggal (mis. viewing
 * tanggal lain di picker) supaya bukan tanggal today yang dipakai.
 */
const toRefDate = (planDate, fallbackRef) => {
  if (!planDate) return fallbackRef;
  if (planDate instanceof Date) return planDate;
  // planDate = "YYYY-MM-DD" — parse jadi Date local midnight
  const [y, mo, da] = String(planDate).split("-").map((n) => parseInt(n, 10));
  if (!y || !mo || !da) return fallbackRef;
  const d = new Date(fallbackRef);
  d.setFullYear(y, mo - 1, da);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const formatHM = (d) =>
  `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;

/**
 * Compute effective departure + startup moments for a row.
 * - departureAt = PDF start_time + totalOffsetMinutes(row)
 * - startupAt   = departureAt − 30 min
 *
 * Untuk row `is_next_day=true`, geser 24 jam ke depan.
 *
 * `planDate` opsional (YYYY-MM-DD atau Date). Kalau di-supply, dipakai
 * sebagai anchor tanggal untuk time-of-day (bukan tanggal `ref/now`).
 * Berguna saat user browse tanggal lain di picker atau saat plan berisi
 * carried-over rows yang jam-nya dini hari.
 */
export const eventsForRow = (row, ref, planDate) => {
  const anchor = toRefDate(planDate, ref);
  const rawDep = parseHM(row.start_time, anchor);
  const offset = totalOffsetMinutes(row);
  let departureAt = new Date(rawDep.getTime() + offset * 60 * 1000);
  if (row?.is_next_day) {
    departureAt = new Date(departureAt.getTime() + 24 * 60 * 60 * 1000);
  }
  const startupAt = new Date(departureAt.getTime() - 30 * 60 * 1000);
  return {
    departureAt,
    startupAt,
    offsetMinutes: offset,
    isSpecialOrigin: isSpecialOrigin(row),
    isNextDay: !!row?.is_next_day,
    isFromDal: isFromDal(row),
  };
};
